import { useState, useRef } from "react";
import { Check, Palette } from "lucide-react";

const COLORS = [
  { name: "Turquoise doux", value: "#5FC7BC" },
  { name: "Lavande", value: "#C9B8E8" },
  { name: "Pêche", value: "#F6C89A" },
  { name: "Vert d'eau", value: "#A8D8C8" },
  { name: "Rose poudré", value: "#F3C1CE" },
  { name: "Bleu ciel", value: "#A9D3EC" },
];

export default function ColorsPlayer({ onComplete }) {
  const [idx, setIdx] = useState(0);
  const start = useRef(Date.now());
  const c = COLORS[idx];

  return (
    <div className="w-full max-w-xl mx-auto text-center" data-testid="colors-player">
      <button onClick={() => setIdx((i) => (i + 1) % COLORS.length)} data-testid="colors-swatch"
        className="w-full h-80 rounded-[2rem] mb-6 flex flex-col items-center justify-center gap-3 border-4 border-black/5 active:scale-[0.99] transition-transform"
        style={{ backgroundColor: c.value }}>
        <Palette className="w-12 h-12 text-white/80" />
        <span className="font-patient font-black text-white text-3xl drop-shadow">{c.name}</span>
      </button>
      <p className="font-patient text-xl text-gray-500 mb-8">Touchez la couleur pour en changer, respirez et détendez-vous.</p>
      <button onClick={() => onComplete({ score: 100, accuracy: 100, duration: Math.round((Date.now() - start.current) / 1000) })}
        data-testid="colors-done"
        className="w-full h-16 rounded-2xl bg-amber-400 text-amber-950 font-patient font-black text-2xl inline-flex items-center justify-center gap-3 active:scale-[0.98] transition-transform">
        Terminé <Check className="w-7 h-7" />
      </button>
    </div>
  );
}
